<template>
  <div id="bto-parts-palette-label">
    <div class="label-group">
      <button
        class="label-category"
        @click="
          () => {
            labelSelect = 'all';
          }
        "
      >
        {{ labelCategory["all"] }}
      </button>
    </div>
    <div class="label-group">
      <button
        class="label-category"
        @click="
          () => {
            labelSelect = 'option_mp';
          }
        "
      >
        {{ labelCategory["mp"] }}
      </button>
    </div>
    <o-dropdown
      class="label-group"
      aria-role="list"
      :mobileModal="false"
      v-for="(labels, key) in partsLabel"
      :key="key"
    >
      <template v-slot:trigger>
        <button class="label-category">
          <span>{{ labelCategory[key] }}</span>
        </button>
      </template>

      <o-dropdown-item
        class="label-list"
        aria-role="listitem"
        v-for="(label, k) in labels"
        :key="k"
        @click="
          (e) => {
            labelSelect = label.labelCode;
          }
        "
      >
        {{ label.name }}
      </o-dropdown-item>
    </o-dropdown>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "PartsPaletteLabel",

  props: {
    partsLabel: {
      type: Object,
    },
    labelCategory: {
      type: Object,
    },
  },

  data() {
    return {};
  },

  computed: {
    /**
     * 選択中のラベルコード
     * @type {Object}
     */
    labelSelect: {
      get() {
        return this.selectedLabelCode;
      },
      set(value) {
        this.updateSelectedLabelCode(value);
      },
    },

    ...mapState({
      selectedLabelCode: (state) => state.selectedLabelCode,
    }),
  },

  methods: {
    ...mapMutations(["updateSelectedLabelCode"]),
  },
};
</script>

<style scoped lang="stylus">

@css {

  #bto-parts-palette-label {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    @apply grid gap-1 mb-1
  }
  #bto-parts-palette-label button {
    color: #876e5e;
    @apply focus:outline-none
  }
  #bto-parts-palette-label .label-group {
    border-color: #efebe3;
    @apply text-center rounded-sm border px-0 py-1 bg-white text-xs text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500
  }
  #bto-parts-palette-label .label-category svg {
    width: 1em;
    @apply inline-block
  }
  #bto-parts-palette-label .label-list {
    @apply text-center
  }
  #bto-parts-palette-label .label-list .button {
    @apply text-center bg-white
  }

}
</style>
